import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import { useGetAllChapterQuery } from "App/services/chapterServiceApi";
import { useGetQuestionChaptersQuery, useUpdateQuestionMutation } from "App/services/QuestionServiceApi";
import { Icon, IconButton } from "@mui/material";
// import JoditEditor from "jodit-react";
import { toast } from "react-toastify";
// import JoditEditor from "jodit-react";
// import { config } from "components/EditorConfig";
import EditorComponents from "components/Editor/EditorComponents";
import JoditEditor from "jodit-react";
import ChapterDragDrop from "./ChapterDragDrop";

const EditNotesFormDialogue = ({ question }) => {
  // const editorRef = useRef(null);
  const editor = React.useRef(null);
  const [open, setOpen] = useState(false);
  const [noteContent, setNoteContent] = useState(question.notes || "");
  const [chapterId, setChapterId] = useState(question.chapter_id || "");
    const [videoLink, setVideoLink] = useState(question.video_link || "");
  const [appliedChapters, setAppliedChapters] = useState([]);
  
  const navigate = useNavigate();

  const {
    data: allChapters,
    error: questionsError,
    isLoading: questionsLoading,
  } = useGetAllChapterQuery();

  const {
    data: questionChapters,
  } = useGetQuestionChaptersQuery(question.id, { skip: !open });

  const [updateQuestion, { isLoading, isError, error }] = useUpdateQuestionMutation();

  useEffect(() => {
    if (questionChapters) {
      setAppliedChapters(questionChapters.map((c) => c.id));
    }
  }, [questionChapters]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditNotes = async (event) => {
    event.preventDefault();

    if (noteContent) {
      let newNoteContent = noteContent.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')

      try {
        await updateQuestion({
          id: question.id,
          notes: newNoteContent[0],
          video_link: videoLink,
          chapters: appliedChapters,
        });
        toast.success("Notes Successfully Updated!");

        handleClose();
      } catch (err) {
        toast.error("Something went wrong!!");
      }
    } else {
      toast.error("Required to Notes");
    }
  };

  // const handleEditorChange = (content) => {
  //   setNoteContent(content);
  // };

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: handleEditNotes,
        }}
      >
        <DialogTitle>Edit Notes</DialogTitle>
        <DialogContent>
          <DialogContentText>Update the details of the Notes:</DialogContentText>

          <JoditEditor
            ref={editor}
            value={noteContent}
            // config={config}
            onChange={(newNoteContent) => setNoteContent(newNoteContent)}
          /> 

          {/* <EditorComponents content={noteContent} handleChangeContent={(newNoteContent) => setNoteContent(newNoteContent)}/> */}

          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={noteContent}
            init={init}
            onEditorChange={handleEditorChange}
          /> */}
   <TextField
            margin="dense"
            id="videoLink"
            label="Video Link"
            fullWidth
            variant="outlined"
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Chapter Applied
            </Typography>
            {questionsLoading ? (
              <Typography variant="body2" color="text.secondary">
                Loading chapters...
              </Typography>
            ) : (
              <ChapterDragDrop
                chapters={allChapters || []}
                value={appliedChapters}
                onChange={setAppliedChapters}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit">
            Update {isLoading && "Loading..."}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default EditNotesFormDialogue;
